'use strict';

var keyboardAccessibility = require('base/components/keyboardAccessibility');
//var states = require('improove/util/states');

var clearSelection = function (element) {
    $(element).closest('.dropdown').children('.dropdown-menu').children('.top-category')
        .detach();
    $(element).closest('.dropdown.show').children('.nav-link').attr('aria-expanded', 'false');
    $(element).closest('.dropdown.show').children('.dropdown-menu').attr('aria-hidden', 'true');
    $(element).closest('.dropdown.show').removeClass('show');
    $('div.menu-group > ul.nav.navbar-nav > li.nav-item > a').attr('aria-hidden', 'false');
    $(element).closest('li').detach();
};

function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) {
        return match[2];
    } else {
        return null;
    }
}

function setCookie(name, value) {
    document.cookie = name + "=" + (value || "") + "; path=/; Secure; SameSite=Strict";
}

function updateBannerVisibility() {
    var banner = $('.headerLoggedOutExpiryPassword')[0];
    if (!banner) return;
    var passwordResetCookieValue = getCookie('passwordResetRequired');
    var currentPath = $('.page').data('action') || '';
    // If we are in resetpassword page, don't show banner
    if (currentPath.indexOf('Account-EditPassword') !== -1) {
        banner.style.display = 'none';
    } else {
        // If cookie is set to TRUE show banner, otherwise hide it
        banner.style.display = (passwordResetCookieValue === 'TRUE') ? 'block' : 'none';
    }
}

$('.headerLoggedOutExpiryPassword .close-button').on('click', function () {
    var banner = $('.headerLoggedOutExpiryPassword')[0];
    if (banner) {
        banner.style.display = 'none';

        var passwordResetCookieValue = getCookie('passwordResetRequired');
        if (passwordResetCookieValue === 'TRUE') {
            setCookie('passwordResetRequired', 'FALSE');
        }
    }
});

$(document).ready(function() {
    updateBannerVisibility();
});

module.exports = function () {
    require('improove/util/states').add('menu', $('.state-container--menu'), $('.menu-state-trigger'), {
        onActivate: function () {
            $('.menu-main-container').addClass('active');
            $('body').addClass('overflowhidden');
        },
        onDeactivate: function () {
            $('.menu-main-container').removeClass('active');
            $('body').removeClass('overflowhidden');
        }
    });

    var isDesktopMenu = function (element) {
        return $(element).parents('.menu-main').hasClass('show-for-large');
    }

    // Handle the close button click event for the password expiry banner
    $(function () {
        var closeButton = $('.headerLoggedOutExpiryPassword .close-button');
        if (closeButton.length) {
            closeButton.on('click', function () {
                var banner = $('.headerLoggedOutExpiryPassword');
                if (banner.length) {
                    banner.hide();

                    // Set the 'passwordResetRequired' cookie to 'FALSE' to prevent the banner from reappearing
                    document.cookie = 'passwordResetRequired=FALSE; path=/';
                }
            });
        }
    });

    // check if header is on top or not
    $(window).scroll(function () {
        var scrollPos = $(document).scrollTop();

        if (scrollPos === 0) {
            $('.menu-main-container').removeClass('not-on-top');
        } else {
            $('.menu-main-container').addClass('not-on-top');
        }
    });

    keyboardAccessibility('.main-menu .nav-link, .main-menu .dropdown-link',
        {
            40: function (menuItem) { // down
                if (menuItem.hasClass('nav-item')) { // top level
                    $('.navbar-nav .show').removeClass('show')
                        .children('.dropdown-menu')
                        .removeClass('show');
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                } else {
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    if (!(menuItem.next().length > 0)) { // if this is the last menuItem
                        menuItem.parent().parent().find('li > a') // set focus to the first menuitem
                            .first()
                            .focus();
                    } else {
                        menuItem.next().children().first().focus();
                    }
                }
            },
            39: function (menuItem) { // right
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.next().children().first().focus();
                } else if (menuItem.hasClass('dropdown')) {
                    menuItem.addClass('show').children('.dropdown-menu').addClass('show');
                    $(this).attr('aria-expanded', 'true');
                    menuItem.find('ul > li > a')
                        .first()
                        .focus();
                }
            },
            38: function (menuItem) { // up
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                } else if (menuItem.prev().length === 0) { // first menuItem
                    menuItem.parent().parent().removeClass('show')
                        .children('.nav-link')
                        .attr('aria-expanded', 'false');
                    menuItem.parent().children().last().children() // set the focus to the last menuItem
                        .first()
                        .focus();
                } else {
                    menuItem.prev().children().first().focus();
                }
            },
            37: function (menuItem) { // left
                if (menuItem.hasClass('nav-item')) { // top level
                    menuItem.removeClass('show').children('.dropdown-menu').removeClass('show');
                    $(this).attr('aria-expanded', 'false');
                    menuItem.prev().children().first().focus();
                } else {
                    menuItem.closest('.show').removeClass('show')
                        .closest('li.show').removeClass('show')
                        .children()
                        .first()
                        .focus()
                        .attr('aria-expanded', 'false');
                }
            },
            27: function (menuItem) { // escape
                var parentMenu = menuItem.hasClass('show')
                    ? menuItem
                    : menuItem.closest('li.show');
                parentMenu.children('.show').removeClass('show');
                parentMenu.removeClass('show').children('.nav-link')
                    .attr('aria-expanded', 'false');
                parentMenu.children().first().focus();
            }
        },
        function () {
            return $(this).parent();
        }
    );


    $('.menu-level-1-item')
        .on('mouseenter', function () {
            if (isDesktopMenu(this)) {
                var eventElement = this;
                $('.menu-level-1-item.collapsible').each(function () {
                    if (!$.contains(this, eventElement)) {
                        $(this).find('.active').each(function () {
                            clearSelection(this);
                        });
                        if ($(this).hasClass('active')) {
                            $(this).children('.collapsible-content').css('display', 'none');
                            $('.dropdown-menu').children('.menu-level--2').removeClass('active');
                            $(this).removeClass('active');
                        }
                    }
                });
                $(this).addClass('active');
                $(this).children('.collapsible-content').css('display', 'block');
                $('.dropdown-menu').children('.menu-level--2').addClass('active');
                $(this).attr('aria-expanded', 'true');
            }
        })
        .on('mouseleave', function () {
            if (isDesktopMenu(this)) {
                $('.menu-category-level-1 > .collapsible').each(function () {
                    $(this).removeClass('active');
                    $(this).children('.collapsible-content').css('display', 'none');
                    $('.dropdown-menu').children('.menu-level--2').removeClass('active');
                });
            }
        });

    $('.navbar>.close-menu>.close-button').on('click', function (e) {
        e.preventDefault();
        $('.menu-toggleable-left').removeClass('in');
        $('.modal-background').hide();

        $('.navbar-toggler').focus();

        $('.main-menu').attr('aria-hidden', 'true');
        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');
    });

    $('.navbar-nav').on('click', '.back', function (e) {
        e.preventDefault();
        clearSelection(this);
    });

    $('.navbar-nav').on('click', '.close-button', function (e) {
        e.preventDefault();
        $('.navbar-nav').find('.top-category').detach();
        $('.navbar-nav').find('.nav-menu').detach();
        $('.navbar-nav').find('.show').removeClass('show');
        $('.menu-toggleable-left').removeClass('in');

        $('.main-menu').siblings().attr('aria-hidden', 'false');
        $('header').siblings().attr('aria-hidden', 'false');

        $('.modal-background').hide();
    });

    keyboardAccessibility('.navbar-header .user',
        {
            40: function ($popover) { // down
                if ($popover.children('a').first().is(':focus')) {
                    $popover.next().children().first().focus();
                } else {
                    $popover.children('a').first().focus();
                }
            },
            38: function ($popover) { // up
                if ($popover.children('a').first().is(':focus')) {
                    $(this).focus();
                    $popover.removeClass('show');
                } else {
                    $popover.children('a').first().focus();
                }
            },
            27: function () { // escape
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            },
            9: function () { // tab
                $('.navbar-header .user .popover').removeClass('show');
                $('.user').attr('aria-expanded', 'false');
            }
        },
        function () {
            var $popover = $('.user .popover li.nav-item');
            return $popover;
        }
    );

    $('.navbar-header .user').on('mouseenter focusin', function () {
        if ($('.navbar-header .user .popover').length > 0) {
            $('.navbar-header .user .popover').addClass('show');
            $('.user').attr('aria-expanded', 'true');
        }
    });

    $('.navbar-header .user').on('mouseleave', function () {
        $('.navbar-header .user .popover').removeClass('show');
        $('.user').attr('aria-expanded', 'false');
    });
    $('body').on('click', '#myaccount', function () {
        event.preventDefault();
    });
};
